import { DefaultQuestions } from '../model';

export const DEFAULT_QUESTIONS: DefaultQuestions = {
  ankles: {
    default_question_ankles_visible: {
      order: 1,
      required: true,
    },
  },
  breasts: {
    default_question_amount_of_fibroglandular_tissue: {
      informativeText: 'FCT.REPORTING.ENTRY.ORGAN.DEFAULT_QUESTIONS.FGT_INFORMATIVE_TEXT',
      order: 2,
      questions: {
        tissue_density: {
          label: 'Fibroglandular Tissue (FGT)',
        },
      },
      required: true,
      requiredWhen: {
        condition: {
          condition: 'mastectomy',
          field: 'laterality',
          value: 'bilateral',
        },
        operator: 'not',
      },
    },
  },
  gallbladder_and_biliary_system: {
    default_question_gallbladder_appearance: {
      order: 1,
      required: true,
    },
  },
  ovaries: {
    default_question_ovary_appearance: {
      order: 1,
      required: true,
    },
  },
  prostate: {
    default_question_total_size_of_prostate: {
      order: 1,
      required: false,
      requiredWhen: {
        condition: {
          condition: 'prostatectomy',
        },
        operator: 'not',
      },
    },
  },
  spine: {
    default_question_conus_level: {
      order: 2,
    },
    default_question_vertebrae_numbering: {
      header: 'Spine count',
      order: 1,
      questions: {
        number_of_c_spine_vertebrae: {
          default_value: '7',
          label: '# of C-spine vertebrae',
        },
        number_of_l_spine_vertebrae: {
          default_value: '5',
          label: '# of L-spine vertebrae',
        },
        number_of_t_spine_vertebrae: {
          default_value: '12',
          label: '# of T-spine vertebrae',
        },
      },
      required: true,
    },
  },
  stomach: {
    default_question_fasted: {
      order: 1,
      questions: {
        patient_fasted: {
          label: 'Has the patient fasted appropriately (ie. No evidence of peristalsis)',
        },
      },
    },
  },
  uterus: {
    default_question_c_section_scar: {
      order: 3,
    },
    default_question_endometrial_thickness: {
      order: 2,
      requiredWhen: {
        condition: [
          {
            condition: 'default_question_uterus_appearance',
            field: 'uterus_appearance',
            value: 'absent',
          },
          {
            condition: 'default_question_uterus_appearance',
            field: 'uterus_appearance',
            value: 'not visualized',
          },
          {
            condition: 'default_question_uterus_appearance',
            field: 'uterus_appearance',
            value: 'partially absent',
          },
        ],
        operator: 'not',
      },
    },
    default_question_intrauterine_device: {
      order: 4,
    },
    default_question_uterus_appearance: {
      order: 1,
      required: false,
    },
  },
};

export const HIDDEN_QUESTION_ORGANS = ['stomach'];

export const VERTEBRAE_NUMBERING_CONDITION = 'default_question_vertebrae_numbering';
